const normalizedHash = (hash: number, min: number, max: number) =>
    Math.floor(hash % (max - min) + min);

export const getColorFromString = (str: string): string => {
    let hash = 0;
    for (let i = 0; i < str.length; i++)
        // eslint-disable-next-line no-bitwise
        hash = Math.abs(str.charCodeAt(i) + ((hash << 5) - hash));

    const h = normalizedHash(hash, 0, 360);
    const s = normalizedHash(hash, 70, 90);
    const l = normalizedHash(hash, 40, 60);

    return `hsl(${h},${s}%,${l}%)`;
};
